import { render, staticRenderFns } from "./TaskIndexCard.vue?vue&type=template&id=72e92dfa&scoped=true&"
import script from "./TaskIndexCard.vue?vue&type=script&lang=js&"
export * from "./TaskIndexCard.vue?vue&type=script&lang=js&"
import style0 from "./TaskIndexCard.vue?vue&type=style&index=0&id=72e92dfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e92dfa",
  null
  
)

export default component.exports